module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "newResidual"
    }
  }, [_c('el-row', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-col', {
    staticClass: "fl",
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.backGo()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    attrs: {
      "span": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fl searthPart",
    staticStyle: {
      "width": "17%"
    }
  }, [_c('p', {
    staticClass: "headerT"
  }, [_vm._v("残值信息")]), _vm._v(" "), _c('el-form', {
    ref: "returnForm",
    attrs: {
      "model": _vm.returnForm,
      "label-width": "80px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "残值单号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.scrapValueCode),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "scrapValueCode", $$v)
      },
      expression: "returnForm.scrapValueCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "操作类型"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.operatorName),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "operatorName", $$v)
      },
      expression: "returnForm.operatorName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "操作人"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.createName),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "createName", $$v)
      },
      expression: "returnForm.createName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提交时间"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.updateTime),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "updateTime", $$v)
      },
      expression: "returnForm.updateTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    staticStyle: {
      "width": "81%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "index",
      "width": "50",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "code",
      "width": "150",
      "label": "序列号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "forecastValue",
      "width": "200",
      "label": "预估残值"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "totalDiv"
  }, [_c('small', [_vm._v("数量：")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.totalCount))]), _vm._v("     \n            "), _c('span', [_c('small', [_vm._v("总计：")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.totalMoney))]), _vm._v(" 元\n            ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-6baa30a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/storehouseManage/wasteManagement/residualManageInfo.vue
// module id = 1704
// module chunks = 0